var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "95%" } },
    [
      _vm.loading
        ? [_c("Loader", { attrs: { delay: 0 } })]
        : [
            _c(
              "b-form",
              [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "IDI" }
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                value: _vm.feature.id.split(".")[1],
                                disabled: ""
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Código" }
                          },
                          [
                            _c("b-form-input", {
                              attrs: { disabled: "" },
                              model: {
                                value: _vm.feature.properties.building_id,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.feature.properties,
                                    "building_id",
                                    $$v
                                  )
                                },
                                expression: "feature.properties.building_id"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Status Modificado" }
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                value: _vm.feature.properties.modified_status,
                                disabled: ""
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "ID Área Lote" }
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                value: _vm.feature.properties.lot_area_id,
                                disabled: ""
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Provincia" }
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                value:
                                  _vm.feature.properties.nombre_provincia_zeus,
                                disabled: ""
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Municipio" }
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                value:
                                  _vm.feature.properties.nombre_municipio_zeus,
                                disabled: ""
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Población" }
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                value:
                                  _vm.feature.properties.nombre_poblacion_zeus,
                                disabled: ""
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "2" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Tipo Entidad Población" }
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                value: _vm.feature.properties.tipo_entidad_zeus,
                                disabled: ""
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "2" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Código Vía" }
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                value: _vm.feature.properties.cod_street_gas,
                                disabled: ""
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Dirección postal" }
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                value:
                                  _vm.feature.properties.name_type +
                                  " " +
                                  _vm.feature.properties.street_name +
                                  " " +
                                  _vm.feature.properties.building_number +
                                  " " +
                                  (_vm.feature.properties.additional_annex ||
                                    ""),
                                disabled: ""
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "2" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Código postal" }
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                value: _vm.feature.properties.zip_code,
                                disabled: ""
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: {
                              label: "Distancia a Red Dist. en servicio (m)"
                            }
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                value:
                                  _vm.feature.properties
                                    .in_service_mains_distance,
                                disabled: ""
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: {
                              label: "Distancia a Red Dist. no abandonada (m)"
                            }
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                value:
                                  _vm.feature.properties
                                    .not_abandoned_mains_distance,
                                disabled: ""
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: {
                              label: "Distancia a Red AP en servicio (m)"
                            }
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                value:
                                  _vm.feature.properties
                                    .high_press_main_in_service_dis,
                                disabled: ""
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: {
                              label: "Distancia a Red AP no abandonada (m)"
                            }
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                value:
                                  _vm.feature.properties
                                    .high_pressure_mains_distance,
                                disabled: ""
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Precisión coordenada" }
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                value:
                                  _vm.feature.properties.precision_coordenada,
                                disabled: ""
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Parcela catastral" }
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                value: _vm.feature.properties.parcela_catastral,
                                disabled: ""
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Excención derechos alta" }
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                value:
                                  _vm.feature.properties
                                    .exemption_register_rights,
                                disabled: ""
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Latitud" }
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                value: _vm.feature.properties.coordinate_y,
                                disabled: ""
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Longitud" }
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                value: _vm.feature.properties.coordinate_x,
                                disabled: ""
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "EPSG" }
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                value: _vm.feature.properties.epsg,
                                disabled: ""
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-form-group",
                          {
                            staticStyle: { "font-size": "1rem" },
                            attrs: { label: "Exención Canon" }
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                value:
                                  _vm.feature.properties.canon_type_id
                                    .canon_type_description || "",
                                disabled: ""
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Modules/Map/DetailsResidencial/Identificacion.vue?vue&type=template&id=7ec99800&
// module id = null
// module chunks = 